import { useRouteError } from "react-router";
import { FC } from "react";
import styles from "./ErrorPage.module.less";
import { Heading } from "@digipost/dds-heading-react";
import Translated from "../infrastructure/translation/Translated";
import { isErrorWithDisplayMessage } from "../infrastructure/errors/useUnrecoverableError";
import { TranslationKey } from "../infrastructure/translation/translator";

const ErrorPage: FC = () => {
  const error = useRouteError();

  const errorTextKey: TranslationKey = isErrorWithDisplayMessage(error)
    ? (error.message as TranslationKey)
    : "errorpage.body";

  console.error(error);

  return (
    <div className={styles.outerContainer}>
      <Heading level={1} size={"large"}>
        <Translated textKey={"errorpage.header"} />
      </Heading>
      <p>
        <Translated textKey={errorTextKey} />
      </p>
    </div>
  );
};

export default ErrorPage;
